import {
  Close,
  Delete as DeleteIcon,
  ExpandLess as ExpandLessIcon,
  ExpandMore as ExpandMoreIcon,
  Upload as UploadIcon,
  Visibility as VisibilityIcon,
} from "@mui/icons-material";
import DescriptionIcon from "@mui/icons-material/Description";
import ErrorIcon from "@mui/icons-material/Error";
import ReceiptIcon from "@mui/icons-material/Receipt";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import ViewStreamIcon from "@mui/icons-material/ViewStream";
import WarningIcon from "@mui/icons-material/Warning";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import {
  Alert,
  AlertTitle,
  Autocomplete,
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Input,
  Skeleton,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { CustomButton } from "src/Components/Common/Button/CustomButton";
import LoadingIcon from "src/Components/Common/LoadingIcon";
import { DIALOG_MAX_WIDTHS } from "src/Components/Common/Modal/ModalWidth";
import useFetch from "src/Components/Common/useFetch";
import { userContext } from "src/Components/Contexts/userContext";
import CustomToast from "src/Components/CustomToast";
import { UserRole } from "src/entity/models/FrontendActor";
import { API_ENDPOINTS } from "src/Utils/ApiConstants/ApiUrlConstants";
import { formatMoney, ToDineroObj } from "src/Utils/MoneyUtils";
import { uiLoggerNamesInvoiceRejection } from "src/Utils/Recon/UiLogger/Constants";
import uiLogger from "src/Utils/UiLogger";
import TabPanel from "../../NewBusinessPartner/TabPanel";
import {
  IssueCategorizationDescriptions,
  IssueCategorizationOptions,
} from "../../VendorPortal/RejectedInvoicesVendorPortal";
import { InternalResolutionStatus, RejectedInvoicesPriority } from "./RejectedInvoices";

const RejectedInvoicesTakeActionModal = ({
  openRejectedInvoicesResolveModal,
  setOpenRejectedInvoicesResolveModal,
  selectedRowForRejectedInvoicesResolveModal,
  role,
  listSummaryData,
  listOpenInvoices,
  listCloseInvoices,
  isCommentModalOpen,
  setIsCommentModalOpen,
}) => {
  const { actor } = useContext(userContext);
  const financeTeamEmails = [
    "mangala.b_ch@external.swiggy.in",
    "priyabrata.nayak_prm@external.scootsy.com",
    "shilp.c_prm@external.scootsy.com",
    "tharun.s_shc@external.swiggy.in",
    "tushar.sen_shc@external.swiggy.in",
    "narendra.prajwal_shc@external.scootsy.com",
    "naveen.a_dte@external.swiggy.in",
    "anusharma2.ext@deloitte.com",
    "sachin.k@nakad.co",
    "oprakash1@deloitte.com",
    "chandan.b_sch@external.scootsy.com",
    "mangala.koramar_sch@external.scootsy.com",
    "tannu.labh_sch@external.scootsy.com",
    "harshitha.t_shc@external.scootsy.com",
    "naveena.k_shc@external.scootsy.com",
    "usha.bn_prm@external.scootsy.com",
    "soniya.chaudhary_shc@external.scootsy.com",
    "vijeta.selani_shc@external.scootsy.com",
    "swati.shirke_shc@external.scootsy.com",
    "ashwini.raut_shc@external.scootsy.com",
    "srinivasulu.1_prm@external.scootsy.com",
    "deepa.a1_prm@external.scootsy.com",
    "yashavantha.m_prm@external.scootsy.com",
    "sanjay.cv_prm@external.scootsy.com",
    "shaik.kabeer_prm@external.scootsy.com",
    "pruthvi.g1_prm@external.scootsy.com",
    "mangala.koramar_shc@external.scootsy.com",
    "tannu.labh_shc@external.scootsy.com",
    "chandan.b_shc@external.scootsy.com",
    "harshitha.t_shc@external.scootsy.com",
    "nicky.kumari_shc@external.scootsy.com",
    "tharun.s_shc@external.swiggy.in",
    "naveena.k_shc@external.scootsy.com",
    "mangala.b_ch@external.swiggy.in",
    "shilp.c_prm@external.scootsy.com",
    "priyabrata.nayak_prm@external.scootsy.com",
    "narendra.prajwal_shc@external.scootsy.com",
    "tushar.sen_shc@external.swiggy.in",
    "anusharma2.ext@deloitte.com",
  ];
  const issueDetails = [
    {
      label: "GRN Date",
      value: selectedRowForRejectedInvoicesResolveModal?.grnDate
        ? moment(selectedRowForRejectedInvoicesResolveModal?.grnDate).format("DD/MM/YYYY")
        : "-",
    },
    { label: "GRN Number", value: selectedRowForRejectedInvoicesResolveModal?.grnNumber },
    {
      label: "GRN Amount",
      value: selectedRowForRejectedInvoicesResolveModal?.grnAmount
        ? formatMoney(ToDineroObj(selectedRowForRejectedInvoicesResolveModal.grnAmount))
        : "-",
    },
  ];

  const otherDetailsRows = [
    [
      { label: "Category", value: selectedRowForRejectedInvoicesResolveModal?.category },
      { label: "Outlet Name", value: selectedRowForRejectedInvoicesResolveModal?.outletName },
      { label: "City", value: selectedRowForRejectedInvoicesResolveModal?.city },
    ],
    [
      { label: "Invoice Number", value: selectedRowForRejectedInvoicesResolveModal?.invoiceNumber },

      { label: "PO Number", value: selectedRowForRejectedInvoicesResolveModal?.poNumber },
      { label: "Item Type", value: selectedRowForRejectedInvoicesResolveModal?.itemType },
    ],
    [{ label: "Dependency", value: selectedRowForRejectedInvoicesResolveModal?.dependency }],
  ];
  const [showDetails, setShowDetails] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const [attachments, setAttachments] = useState([]);
  const [fileInput, setFileInput] = useState<HTMLInputElement | null>(null);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [isLoadingRejectInvoice, setIsLoadingRejectInvoice] = useState(false);
  const [isLoadingApproveInvoice, setIsLoadingApproveInvoice] = useState(false);
  const [isLoadingAddInvoiceComment, setIsLoadingAddInvoiceComment] = useState(false);
  const [isLoadingMarkInvoiceCommentAsRead, setIsLoadingMarkInvoiceCommentAsRead] = useState(false);

  const [tabValue, setTabValue] = useState(isCommentModalOpen ? 1 : 0);
  const [openMarkAsApproveConfirmModal, setOpenMarkAsApproveConfirmModal] = useState(false);
  const [openRejectResponseConfirmModal, setOpenRejectResponseConfirmModal] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [openReopenConfirmModal, setOpenReopenConfirmModal] = useState(false);
  const [reopenReason, setReopenReason] = useState("");
  const [isLoadingReopenInvoice, setIsLoadingReopenInvoice] = useState(false);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [isListCommentLoading, setIsListCommentLoading] = useState(false);
  const [openViniculumConfirmModal, setOpenViniculumConfirmModal] = useState(false);
  const [isLoadingUpdateInViniculum, setIsLoadingUpdateInViniculum] = useState(false);

  useEffect(() => {
    listAttachments();
    listComments();
  }, []);
  const listAttachments = () => {
    useFetch(
      API_ENDPOINTS.LIST_INVOICE_ATTACHMENTS(role, selectedRowForRejectedInvoicesResolveModal?.grnNumber).url,
      "GET",
      {
        failureMessage: API_ENDPOINTS.LIST_INVOICE_ATTACHMENTS(
          role,
          selectedRowForRejectedInvoicesResolveModal?.grnNumber
        ).failureMessage,
        thenCallBack: (response) => {
          setAttachments(response.data?.attachments || []);
        },
      }
    );
  };
  const listComments = () => {
    setIsListCommentLoading(true);
    useFetch(
      API_ENDPOINTS.FETCH_INVOICE_COMMENTS(role, selectedRowForRejectedInvoicesResolveModal?.grnNumber).url,
      "GET",
      {
        failureMessage: API_ENDPOINTS.FETCH_INVOICE_COMMENTS(
          role,
          selectedRowForRejectedInvoicesResolveModal?.grnNumber
        ).failureMessage,
        thenCallBack: (response) => {
          setComments(response.data?.comments || []);
          setIsListCommentLoading(false);
        },
        catchCallBack: () => {
          setIsListCommentLoading(false);
        },
      }
    );
  };

  const addInvoiceComment = () => {
    setIsLoadingAddInvoiceComment(true);

    useFetch(
      API_ENDPOINTS.ADD_INVOICE_COMMENT(role, selectedRowForRejectedInvoicesResolveModal?.grnNumber).url,
      "POST",
      {
        failureMessage: API_ENDPOINTS.ADD_INVOICE_COMMENT(role, selectedRowForRejectedInvoicesResolveModal?.grnNumber)
          .failureMessage,

        data: {
          comment: newComment,
        },
        showSuccessToast: true,
        thenCallBack: () => {
          listComments();
          setNewComment("");
          setIsLoadingAddInvoiceComment(false);
        },
        catchCallBack: () => {
          setIsLoadingAddInvoiceComment(false);
        },
      }
    );

    uiLogger(uiLoggerNamesInvoiceRejection.UI_SST_IR_COMMENTS_ADD_CLICK.functionName, null, null, {
      message: uiLoggerNamesInvoiceRejection.UI_SST_IR_COMMENTS_ADD_CLICK.message,
    });
  };
  const markInvoiceCommentAsRead = (commentId) => {
    setIsLoadingMarkInvoiceCommentAsRead(true);

    useFetch(
      API_ENDPOINTS.MARK_COMMENTS_AS_READ(role, selectedRowForRejectedInvoicesResolveModal?.grnNumber).url,
      "POST",
      {
        failureMessage: API_ENDPOINTS.MARK_COMMENTS_AS_READ(role, selectedRowForRejectedInvoicesResolveModal?.grnNumber)
          .failureMessage,

        data: {
          commentId: commentId,
        },
        showSuccessToast: true,
        thenCallBack: () => {
          listComments();
          listSummaryData();
          listOpenInvoices();
          listCloseInvoices();
          setIsLoadingMarkInvoiceCommentAsRead(false);
        },
        catchCallBack: () => {
          setIsLoadingMarkInvoiceCommentAsRead(false);
        },
      }
    );
  };

  const handleCloseMarkAsApproveConfirmModal = () => {
    setOpenMarkAsApproveConfirmModal(false);
  };
  const handleCloseRejectResponseConfirmModal = () => {
    setRejectReason("");
    setOpenRejectResponseConfirmModal(false);
  };
  const handleCloseReopenConfirmModal = () => {
    setReopenReason("");
    setOpenReopenConfirmModal(false);
  };
  const handleCloseViniculumConfirmModal = () => {
    setOpenViniculumConfirmModal(false);
  };

  const handleFileUpload = (event) => {
    const selectedFiles = Array.from(event.target.files);
    const totalFiles = uploadedFiles.length + selectedFiles.length;

    if (totalFiles > 5) {
      toast.error(<CustomToast message="You can only upload up to 5 files." />);
      event.target.value = ""; // Clear input so same files can be re-selected
      return;
    }

    setUploadedFiles((prev) => [...selectedFiles, ...prev]);
    event.target.value = "";

    uiLogger(uiLoggerNamesInvoiceRejection.UI_SST_IR_TAKEACTION_UPLOAD_CLICK.functionName, null, null, {
      message: uiLoggerNamesInvoiceRejection.UI_SST_IR_TAKEACTION_UPLOAD_CLICK.message,
    });
  };

  const handleView = (file) => {
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL, "_blank");

    uiLogger(uiLoggerNamesInvoiceRejection.UI_SST_IR_TAKEACTION_VIEWATTACHMENT_CLICK.functionName, null, null, {
      message: uiLoggerNamesInvoiceRejection.UI_SST_IR_TAKEACTION_VIEWATTACHMENT_CLICK.message,
    });
  };

  const handleDelete = (index) => {
    setUploadedFiles((prev) => prev.filter((_, i) => i !== index));

    uiLogger(uiLoggerNamesInvoiceRejection.UI_SST_IR_TAKEACTION_DELETEATTACHMENT_CLICK.functionName, null, null, {
      message: uiLoggerNamesInvoiceRejection.UI_SST_IR_TAKEACTION_DELETEATTACHMENT_CLICK.message,
    });
  };

  const handleClose = () => {
    setOpenRejectedInvoicesResolveModal(false);
    setIsCommentModalOpen(false);
  };

  const handleViewAttachment = (file) => {
    useFetch(
      API_ENDPOINTS.VIEW_INVOICE_ATTACHMENT(role, selectedRowForRejectedInvoicesResolveModal?.grnNumber).url,
      "POST",
      {
        failureMessage: API_ENDPOINTS.VIEW_INVOICE_ATTACHMENT(
          role,
          selectedRowForRejectedInvoicesResolveModal?.grnNumber
        ).failureMessage,
        data: {
          attachmentLink: file.fileKey,
        },
        thenCallBack: (_res) => {
          const link = document.createElement("a");
          link.href = _res.data.attachment;
          link.target = "_blank";
          link.referrerPolicy = "no-referrer";
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          // window.open(_res.data.attachment, "_blank", "noopener,noreferrer");
        },
      }
    );

    uiLogger(uiLoggerNamesInvoiceRejection.UI_SST_IR_TAKEACTION_VIEWATTACHMENT_CLICK.functionName, null, null, {
      message: uiLoggerNamesInvoiceRejection.UI_SST_IR_TAKEACTION_VIEWATTACHMENT_CLICK.message,
    });
  };

  const handleSubmit = () => {
    setIsLoadingSubmit(true);
    const bodyFormData = new FormData();

    for (const item of uploadedFiles) {
      bodyFormData.append("files", item);
    }

    useFetch(
      API_ENDPOINTS.LIST_INVOICE_ATTACHMENTS(role, selectedRowForRejectedInvoicesResolveModal?.grnNumber).url,
      "POST",
      {
        failureMessage: API_ENDPOINTS.LIST_INVOICE_ATTACHMENTS(
          role,
          selectedRowForRejectedInvoicesResolveModal?.grnNumber
        ).failureMessage,
        config: {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
        data: bodyFormData,
        showSuccessToast: true,
        thenCallBack: () => {
          listSummaryData();
          listOpenInvoices();
          listCloseInvoices();
          setUploadedFiles([]);
          setIsLoadingSubmit(false);
          handleClose();
        },
        catchCallBack: () => {
          setIsLoadingSubmit(false);
        },
      }
    );

    uiLogger(uiLoggerNamesInvoiceRejection.UI_SST_IR_TAKEACTION_SUBMIT_CLICK.functionName, null, null, {
      message: uiLoggerNamesInvoiceRejection.UI_SST_IR_TAKEACTION_SUBMIT_CLICK.message,
    });
  };
  const handleUpdateInViniculum = () => {
    setIsLoadingUpdateInViniculum(true);

    useFetch(API_ENDPOINTS.MARK_UPDATED_IN_VINICULUM(role).url, "POST", {
      failureMessage: API_ENDPOINTS.MARK_UPDATED_IN_VINICULUM(role).failureMessage,
      data: {
        grnNumber: selectedRowForRejectedInvoicesResolveModal?.grnNumber,
      },
      showSuccessToast: true,
      thenCallBack: () => {
        listSummaryData();
        listOpenInvoices();
        listCloseInvoices();
        setUploadedFiles([]);
        setIsLoadingUpdateInViniculum(false);
        handleClose();
      },
      catchCallBack: () => {
        setIsLoadingUpdateInViniculum(false);
      },
    });

    uiLogger(uiLoggerNamesInvoiceRejection.UI_SST_IR_TAKEACTION_SUBMIT_CLICK.functionName, null, null, {
      message: uiLoggerNamesInvoiceRejection.UI_SST_IR_TAKEACTION_SUBMIT_CLICK.message,
    });
  };

  const handleRejectInvoice = () => {
    setIsLoadingRejectInvoice(true);

    useFetch(API_ENDPOINTS.REJECT_INVOICE(role, selectedRowForRejectedInvoicesResolveModal?.grnNumber).url, "POST", {
      failureMessage: API_ENDPOINTS.REJECT_INVOICE(role, selectedRowForRejectedInvoicesResolveModal?.grnNumber)
        .failureMessage,

      data: {
        rejectionReason: rejectReason,
      },
      showSuccessToast: true,
      thenCallBack: () => {
        listSummaryData();
        listOpenInvoices();
        listCloseInvoices();
        setUploadedFiles([]);
        setIsLoadingRejectInvoice(false);
        handleCloseRejectResponseConfirmModal();
        handleClose();
      },
      catchCallBack: () => {
        setIsLoadingRejectInvoice(false);
      },
    });

    uiLogger(uiLoggerNamesInvoiceRejection.UI_SST_IR_TAKEACTION_REJECT_CLICK.functionName, null, null, {
      message: uiLoggerNamesInvoiceRejection.UI_SST_IR_TAKEACTION_REJECT_CLICK.message,
    });
  };
  const handleReopenInvoice = () => {
    setIsLoadingReopenInvoice(true);

    useFetch(
      API_ENDPOINTS.REOPEN_APPROVED_INVOICE(role, selectedRowForRejectedInvoicesResolveModal?.grnNumber).url,
      "POST",
      {
        failureMessage: API_ENDPOINTS.REOPEN_APPROVED_INVOICE(
          role,
          selectedRowForRejectedInvoicesResolveModal?.grnNumber
        ).failureMessage,
        data: {
          reason: reopenReason,
        },
        showSuccessToast: true,
        thenCallBack: () => {
          listSummaryData();
          listOpenInvoices();
          listCloseInvoices();
          setIsLoadingReopenInvoice(false);
          handleCloseReopenConfirmModal();
          handleClose();
        },
        catchCallBack: () => {
          setIsLoadingReopenInvoice(false);
        },
      }
    );
  };
  const handleApproveInvoice = () => {
    setIsLoadingApproveInvoice(true);

    useFetch(API_ENDPOINTS.APPROVE_INVOICE(role, selectedRowForRejectedInvoicesResolveModal?.grnNumber).url, "POST", {
      failureMessage: API_ENDPOINTS.APPROVE_INVOICE(role, selectedRowForRejectedInvoicesResolveModal?.grnNumber)
        .failureMessage,
      showSuccessToast: true,
      thenCallBack: () => {
        listSummaryData();
        listOpenInvoices();
        listCloseInvoices();
        setUploadedFiles([]);
        setIsLoadingApproveInvoice(false);
        handleCloseMarkAsApproveConfirmModal();
        handleClose();
      },
      catchCallBack: () => {
        setIsLoadingApproveInvoice(false);
      },
    });

    uiLogger(uiLoggerNamesInvoiceRejection.UI_SST_IR_TAKEACTION_APPROVE_CLICK.functionName, null, null, {
      message: uiLoggerNamesInvoiceRejection.UI_SST_IR_TAKEACTION_APPROVE_CLICK.message,
    });
  };

  const canTakeActionEnable = () => {
    const issueStatus = selectedRowForRejectedInvoicesResolveModal.issueStatus;

    if (actor?.userRole === UserRole.DRMaker) {
      return (
        issueStatus === InternalResolutionStatus.InProgress ||
        issueStatus === InternalResolutionStatus.RejectedAgain ||
        issueStatus === InternalResolutionStatus.PendingApproval ||
        issueStatus === InternalResolutionStatus.UpdatedInViniculum
      );
    } else if (actor?.userRole === UserRole.DRApprover || actor.userRole === UserRole.ReconDRApprover) {
      return (
        issueStatus === InternalResolutionStatus.Unassigned ||
        issueStatus === InternalResolutionStatus.InProgress ||
        issueStatus === InternalResolutionStatus.PendingApproval ||
        issueStatus === InternalResolutionStatus.RejectedAgain ||
        issueStatus === InternalResolutionStatus.UpdatedInViniculum
      );
    } else if (actor?.userRole === UserRole.DRChecker) {
      return (
        issueStatus === InternalResolutionStatus.Unassigned ||
        issueStatus === InternalResolutionStatus.InProgress ||
        issueStatus === InternalResolutionStatus.PendingApproval ||
        issueStatus === InternalResolutionStatus.RejectedAgain ||
        issueStatus === InternalResolutionStatus.UpdatedInViniculum
      );
    }

    return false; // Default case: no action allowed
  };
  // An approval made by mistake (e.g. wrong invoice attached) can be undone by an approver until
  // Instamart posts the GRN; reopening sends it back to "Rejected Again" so it can be re-uploaded.
  const canReopenApprovedInvoice = () =>
    (actor?.userRole === UserRole.DRApprover || actor?.userRole === UserRole.ReconDRApprover) &&
    selectedRowForRejectedInvoicesResolveModal.issueStatus === InternalResolutionStatus.InvoiceProcessing;

  return (
    <>
      <Dialog open={openRejectedInvoicesResolveModal} maxWidth={DIALOG_MAX_WIDTHS.SM} fullWidth>
        <DialogTitle className="dialog-title">
          <div className="heading-m">{selectedRowForRejectedInvoicesResolveModal?.vendorName || ""}</div>
          <div className="vertical_center_align">
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </div>
        </DialogTitle>

        <DialogContent dividers sx={{ p: 2 }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={tabValue}
              onChange={(e, val) => {
                e.preventDefault();
                setTabValue(val);
                //   setSelectedQF(RejectedInvoicesQuickFilterOptions.All);
                if (val === 1) {
                  uiLogger(uiLoggerNamesInvoiceRejection.UI_SST_IR_COMMENTS_CLICK.functionName, null, null, {
                    message: uiLoggerNamesInvoiceRejection.UI_SST_IR_COMMENTS_CLICK.message,
                  });
                }
              }}
              sx={{
                minHeight: 44,
                "& .MuiTabs-indicator": {
                  backgroundColor: "#531c4c",
                },
                "& .MuiChip-root": {
                  color: "#fff",
                  bgcolor: "#0009",
                  px: "6.5px",
                  py: 0,
                },
                "& .Mui-selected": {
                  color: "#531c4c !important",
                  "& .MuiChip-root": {
                    bgcolor: "#531c4c",
                  },
                },
              }}
            >
              <Tab label="Upload" sx={{ textTransform: "none", minHeight: "auto" }} />
              <Tab label="Comments" sx={{ textTransform: "none", minHeight: "auto" }} />
            </Tabs>
          </Box>

          <TabPanel value={tabValue} index={0} sx={{ padding: 0, marginTop: 2 }}>
            <Alert
              severity="warning"
              sx={{
                backgroundColor: "#fff4e5",
                marginBottom: 2,
              }}
            >
              <AlertTitle sx={{ fontWeight: 500 }}>
                {selectedRowForRejectedInvoicesResolveModal.issueCategory || ""}
              </AlertTitle>
              {IssueCategorizationDescriptions[selectedRowForRejectedInvoicesResolveModal.issueCategory] || "-"}
            </Alert>

            <Card sx={{ marginBottom: 2, border: "1px solid #d6d6d6" }}>
              <CardContent sx={{ padding: "16px 24px" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <Box>
                    <Typography className="heading-xs">
                      {canTakeActionEnable() ? "Upload Invoice Copy *" : "Invoice Copy"}
                    </Typography>
                    {canTakeActionEnable() && (
                      <Typography className="body-s-medium" color="textSecondary">
                        Attach your invoice file here (supported formats PDF, JPG, PNG).
                      </Typography>
                    )}
                  </Box>
                  {canTakeActionEnable() && (
                    <>
                      <Input
                        type="file"
                        inputRef={(ref) => setFileInput(ref)}
                        sx={{ display: "none" }}
                        onChange={handleFileUpload}
                        inputProps={{
                          accept: ".pdf,.jpg,.png",
                        }}
                      />
                      <CustomButton
                        size="small"
                        colorToken="violet"
                        variant="outlined"
                        startIcon={<UploadIcon />}
                        onClick={() => fileInput?.click()}
                        disabled={uploadedFiles.length >= 5}
                      >
                        Upload
                      </CustomButton>
                    </>
                  )}
                </Box>
              </CardContent>

              {uploadedFiles.map((file, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "8px 24px",
                    backgroundColor: "#f2f2f2",
                    borderTop: "1px solid #d6d6d6",
                  }}
                >
                  <Chip
                    avatar={
                      <Avatar sx={{ backgroundColor: "#541c4c", color: "white" }}>
                        <DescriptionIcon sx={{ fontSize: 14, color: "white" }} />
                      </Avatar>
                    }
                    label={
                      <Box
                        title={file.name}
                        sx={{
                          maxWidth: "250px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {file.name}
                      </Box>
                    }
                    variant="outlined"
                    sx={{
                      maxWidth: "250px",
                      borderColor: "#541c4c",
                      color: "#541c4c",
                      flex: 1, // Allow the chip to take available space
                    }}
                  />
                  <Box sx={{ display: "flex", gap: 1, flexShrink: 0 }}>
                    <CustomButton
                      size="small"
                      colorToken="violet"
                      variant="outlined"
                      startIcon={<VisibilityIcon />}
                      onClick={() => handleView(file)}
                    >
                      View
                    </CustomButton>
                    {canTakeActionEnable() && (
                      <CustomButton
                        size="small"
                        color="error"
                        variant="outlined"
                        startIcon={<DeleteIcon />}
                        onClick={() => handleDelete(index)}
                      >
                        Delete
                      </CustomButton>
                    )}
                  </Box>
                </Box>
              ))}
              {attachments?.length > 0 &&
                attachments?.map((file, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "8px 24px",
                      backgroundColor: "#f2f2f2",
                      borderTop: "1px solid #d6d6d6",
                    }}
                  >
                    <Chip
                      avatar={
                        <Avatar sx={{ backgroundColor: "#541c4c", color: "white" }}>
                          <DescriptionIcon sx={{ fontSize: 14, color: "white" }} />
                        </Avatar>
                      }
                      label={
                        <Box
                          title={file.fileName}
                          sx={{
                            maxWidth: "250px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {file.fileName}
                        </Box>
                      }
                      variant="outlined"
                      sx={{
                        maxWidth: "250px",
                        borderColor: "#541c4c",
                        color: "#541c4c",
                        flex: 1, // Allow the chip to take available space
                      }}
                    />
                    <Box sx={{ display: "flex", gap: 1, flexShrink: 0 }}>
                      <CustomButton
                        size="small"
                        colorToken="violet"
                        variant="outlined"
                        startIcon={<VisibilityIcon />}
                        onClick={() => handleViewAttachment(file)}
                      >
                        View
                      </CustomButton>
                    </Box>
                  </Box>
                ))}
            </Card>

            <Card sx={{ backgroundColor: "#fafafa" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "8px 16px",
                  alignItems: "center",
                }}
              >
                <Box
                  className="heading-xs"
                  sx={{ display: "flex", alignItems: "center", gap: 1, color: "rgba(0, 0, 0, 0.60)" }}
                >
                  <WarningIcon />
                  <Typography className="heading-xs">Priority</Typography>
                </Box>
                <Chip
                  label={selectedRowForRejectedInvoicesResolveModal.priority} // Dynamically set the label
                  color={
                    selectedRowForRejectedInvoicesResolveModal.priority === RejectedInvoicesPriority.High
                      ? "error"
                      : selectedRowForRejectedInvoicesResolveModal.priority === RejectedInvoicesPriority.Medium
                      ? "warning"
                      : selectedRowForRejectedInvoicesResolveModal.priority === RejectedInvoicesPriority.Low
                      ? "primary"
                      : "default" // Default color if no match
                  }
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "8px 16px",
                  alignItems: "center",
                }}
              >
                <Box
                  className="heading-xs"
                  sx={{ display: "flex", alignItems: "center", gap: 1, color: "rgba(0, 0, 0, 0.60)" }}
                >
                  <ErrorIcon />
                  <Typography className="heading-xs">Status</Typography>
                </Box>
                <Chip
                  label={selectedRowForRejectedInvoicesResolveModal.issueStatus} // Dynamically set the label
                  variant="outlined"
                  color={
                    selectedRowForRejectedInvoicesResolveModal.issueStatus === InternalResolutionStatus.InProgress
                      ? "primary"
                      : selectedRowForRejectedInvoicesResolveModal.issueStatus ===
                        InternalResolutionStatus.PendingApproval
                      ? "warning"
                      : selectedRowForRejectedInvoicesResolveModal.issueStatus ===
                        InternalResolutionStatus.InvoiceProcessing
                      ? "success"
                      : selectedRowForRejectedInvoicesResolveModal.issueStatus === InternalResolutionStatus.Posted
                      ? "success"
                      : selectedRowForRejectedInvoicesResolveModal.issueStatus ===
                        InternalResolutionStatus.UpdatedInViniculum
                      ? "primary"
                      : "default" // Default color if no match
                  }
                />
              </Box>

              <Box sx={{ padding: "16px" }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 2,
                  }}
                >
                  <Box
                    className="heading-xs"
                    sx={{ display: "flex", alignItems: "center", gap: 1, color: "rgba(0, 0, 0, 0.60)" }}
                  >
                    <ReceiptIcon />
                    <Typography className="heading-xs">Issue Details</Typography>
                  </Box>
                  <Button
                    endIcon={showDetails ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    sx={{ color: "#0288d1" }}
                    onClick={() => setShowDetails(!showDetails)}
                  >
                    {showDetails ? "Less Info" : "More Info"}
                  </Button>
                </Box>

                <Box sx={{ display: "flex", gap: 2, marginBottom: 3 }}>
                  {issueDetails.map((detail, index) => (
                    <Box
                      key={index}
                      sx={{
                        flex: 1,
                        padding: "8px 12px",
                        border: "1px solid rgba(0, 0, 0, 0.12)",
                        borderRadius: 1,
                      }}
                    >
                      <Typography className="body-s-bold">{detail.label}</Typography>
                      <Typography className="body-s-medium">{detail.value}</Typography>
                    </Box>
                  ))}
                </Box>
                <Collapse in={showDetails}>
                  <Box
                    className="heading-xs"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      marginBottom: 2,
                      color: "rgba(0, 0, 0, 0.60)",
                    }}
                  >
                    <ViewStreamIcon />
                    <Typography className="heading-xs">Other Details</Typography>
                  </Box>

                  {otherDetailsRows.map((row, rowIndex) => (
                    <Box key={rowIndex} sx={{ display: "flex", gap: 2, marginBottom: 2 }}>
                      {row.map((detail, colIndex) => (
                        <Box
                          key={colIndex}
                          sx={{
                            flex: 1,
                            padding: "8px 12px",
                            border: "1px solid rgba(0, 0, 0, 0.12)",
                            borderRadius: 1,
                          }}
                        >
                          <Typography className="body-s-bold">{detail.label}</Typography>
                          <Typography className="body-s-medium">{detail.value}</Typography>
                        </Box>
                      ))}
                    </Box>
                  ))}
                </Collapse>
              </Box>
            </Card>
          </TabPanel>
          <TabPanel value={tabValue} index={1} sx={{ padding: 0 }}>
            <Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  //   padding: '0 24px',
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    gap: "8px",
                    padding: "24px 0",
                    width: "100%",
                  }}
                >
                  <TextField
                    fullWidth
                    placeholder="Add a comment..."
                    size="small"
                    value={newComment}
                    onChange={(e) => setNewComment(e.target.value)}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        height: 40,
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#541c4c", // Violet color for the border when focused
                        },
                      },
                      "& .MuiInputLabel-root.Mui-focused": {
                        color: "#541c4c", // Violet color for the label when focused
                      },
                    }}
                    className="update-custom-border-radius"
                  />
                  <CustomButton
                    size="medium"
                    colorToken="violet"
                    variant="contained"
                    disabled={newComment.trim() === "" || isLoadingAddInvoiceComment}
                    startIcon={<LoadingIcon loading={isLoadingAddInvoiceComment} />}
                    onClick={addInvoiceComment}
                  >
                    Send
                  </CustomButton>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "4px 0",
                    marginBottom: "16px",
                  }}
                >
                  <Typography className="heading-xs">All Comments</Typography>
                  <Button
                    startIcon={<RemoveRedEyeIcon />}
                    className="heading-xs"
                    sx={{
                      color: "#0288d1",
                      textTransform: "none",
                    }}
                    disabled={
                      comments?.filter((comment) => !comment.hasRead)?.length === 0 || isLoadingMarkInvoiceCommentAsRead
                    }
                    onClick={() => {
                      const unreadCommentIds = comments
                        ?.filter((comment) => !comment.hasRead)
                        ?.map((comment) => comment.id);
                      if (unreadCommentIds.length > 0) {
                        markInvoiceCommentAsRead(unreadCommentIds);
                      }

                      uiLogger(
                        uiLoggerNamesInvoiceRejection.UI_SST_IR_TAKEACTION_COMMENTS_MARKASREAD_CLICK.functionName,
                        null,
                        null,
                        {
                          message: uiLoggerNamesInvoiceRejection.UI_SST_IR_TAKEACTION_COMMENTS_MARKASREAD_CLICK.message,
                        }
                      );
                    }}
                  >
                    Mark as read
                  </Button>
                </Box>

                {isListCommentLoading
                  ? // Skeleton Loader
                    Array.from({ length: 3 }).map((_, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "16px 0",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            gap: "8px",
                          }}
                        >
                          <Skeleton variant="circular" width={24} height={24} />
                        </Box>
                        <Box
                          sx={{
                            flex: 1,
                            marginLeft: "8px",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <Skeleton variant="text" width="20%" height={20} />
                            <Skeleton variant="text" width="30%" height={20} />
                          </Box>
                          <Skeleton variant="text" width="80%" height={20} />
                        </Box>
                      </Box>
                    ))
                  : comments?.map((comment) => (
                      <Box
                        key={comment.id}
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "16px 0",
                          //   borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            // alignItems: 'center',
                            gap: "8px",
                          }}
                        >
                          <Avatar
                            sx={{
                              bgcolor: "#541c4c",
                              width: 24,
                              height: 24,
                              fontSize: 9.6,
                              fontWeight: 600,
                            }}
                          >
                            {comment?.name
                              ?.split(" ")
                              ?.map((name) => name[0])
                              ?.join("")}
                          </Avatar>
                        </Box>
                        <Box
                          sx={{
                            flex: 1,
                            marginLeft: "8px",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              //   marginBottom: '4px',
                            }}
                          >
                            <Typography className="heading-xs">{comment.name}</Typography>
                            <Typography
                              className="body-s-medium"
                              sx={{
                                color: "rgba(0, 0, 0, 0.6)",
                              }}
                            >
                              {moment(comment.commentedAt).format("MMMM D, YYYY [at] h:mm A")}
                            </Typography>
                            {comment.isRejectionComment && (
                              <Box
                                sx={{
                                  backgroundColor: "#d32f2f",
                                  borderRadius: 100,
                                  padding: "0 6.5px",
                                  height: 20,
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <Typography
                                  sx={{
                                    color: "#ffffff",
                                    fontSize: 12,
                                    fontWeight: 500,
                                    letterSpacing: 0.14,
                                  }}
                                >
                                  Rejected Remark
                                </Typography>
                              </Box>
                            )}
                          </Box>
                          <Typography className="body-s-medium">{comment.comment}</Typography>
                        </Box>
                        {!comment.hasRead && (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <IconButton
                              onClick={() => {
                                markInvoiceCommentAsRead([comment.id]);
                                uiLogger(
                                  uiLoggerNamesInvoiceRejection.UI_SST_IR_COMMENTS_MARKASREAD_CLICK.functionName,
                                  null,
                                  null,
                                  {
                                    message: uiLoggerNamesInvoiceRejection.UI_SST_IR_COMMENTS_MARKASREAD_CLICK.message,
                                  }
                                );
                              }}
                              disabled={isLoadingMarkInvoiceCommentAsRead}
                            >
                              <RemoveRedEyeIcon />
                            </IconButton>
                          </Box>
                        )}
                      </Box>
                    ))}
              </Box>
            </Box>
          </TabPanel>
        </DialogContent>

        {canTakeActionEnable() && (
          <DialogActions className="dialog-actions space_between">
            <Box>
              {(selectedRowForRejectedInvoicesResolveModal.issueStatus === InternalResolutionStatus.InProgress ||
                selectedRowForRejectedInvoicesResolveModal.issueStatus === InternalResolutionStatus.Unassigned ||
                selectedRowForRejectedInvoicesResolveModal.issueStatus === InternalResolutionStatus.RejectedAgain) &&
                (financeTeamEmails.includes(actor?.userEmail) ? (
                  <CustomButton
                    size="medium"
                    color="primary"
                    variant="outlined"
                    onClick={() => {
                      setOpenMarkAsApproveConfirmModal(true);
                    }}
                  >
                    Mark as approved
                  </CustomButton>
                ) : // "Update in Viniculum" button hidden for now, keep code for future use
                // <CustomButton
                //   size="medium"
                //   color="primary"
                //   variant="outlined"
                //   onClick={() => {
                //     setOpenViniculumConfirmModal(true);
                //   }}
                // >
                //   Update in Viniculum
                // </CustomButton>
                null)}
            </Box>
            <Box>
              <CustomButton size="medium" colorToken="violet" variant="text" onClick={handleClose}>
                Cancel
              </CustomButton>

              {(actor?.userRole === UserRole.DRApprover || actor.userRole === UserRole.ReconDRApprover) &&
              (selectedRowForRejectedInvoicesResolveModal.issueStatus === InternalResolutionStatus.PendingApproval ||
                selectedRowForRejectedInvoicesResolveModal.issueStatus ===
                  InternalResolutionStatus.UpdatedInViniculum) ? (
                <>
                  <CustomButton
                    size="medium"
                    colorToken="violet"
                    variant="outlined"
                    onClick={() => {
                      setOpenRejectResponseConfirmModal(true);
                    }}
                  >
                    Reject response
                  </CustomButton>
                  <CustomButton
                    size="medium"
                    colorToken="violet"
                    variant="contained"
                    sx={{ marginLeft: 1 }}
                    onClick={() => {
                      setOpenMarkAsApproveConfirmModal(true);
                    }}
                  >
                    Mark as approved
                  </CustomButton>
                </>
              ) : (
                <CustomButton
                  size="medium"
                  colorToken="violet"
                  variant="contained"
                  disabled={uploadedFiles?.length === 0 || isLoadingSubmit}
                  startIcon={<LoadingIcon loading={isLoadingSubmit} />}
                  onClick={handleSubmit}
                >
                  Submit
                </CustomButton>
              )}
            </Box>
          </DialogActions>
        )}
        {canReopenApprovedInvoice() && (
          <DialogActions className="dialog-actions">
            <CustomButton size="medium" colorToken="violet" variant="text" onClick={handleClose}>
              Cancel
            </CustomButton>
            <CustomButton
              size="medium"
              color="error"
              variant="outlined"
              onClick={() => {
                setOpenReopenConfirmModal(true);
              }}
            >
              Reopen for re-upload
            </CustomButton>
          </DialogActions>
        )}
      </Dialog>

      {openReopenConfirmModal && (
        <Dialog open={openReopenConfirmModal} maxWidth={DIALOG_MAX_WIDTHS.XS} fullWidth>
          <DialogTitle className="dialog-title">
            <div className="heading-m error-dialog-icon">
              <div>
                <WarningAmberIcon color="error" />
              </div>
              Reopen approved GRN?
            </div>
            <div className="vertical_center_align">
              <IconButton onClick={handleCloseReopenConfirmModal}>
                <Close />
              </IconButton>
            </div>
          </DialogTitle>
          <DialogContent dividers sx={{ p: 2 }}>
            <Alert severity="warning" sx={{ mb: 2 }}>
              The approval will be withdrawn and the GRN will move back to "Rejected Again" so the correct invoice can
              be uploaded.
            </Alert>
            <TextField
              fullWidth
              placeholder="Why is this GRN being reopened? (e.g. wrong invoice attached)"
              size="small"
              multiline
              maxRows={4}
              value={reopenReason}
              onChange={(event) => setReopenReason(event.target.value)}
              className="update-custom-border-radius"
            />
          </DialogContent>
          <DialogActions className="dialog-actions">
            <CustomButton size="medium" color="error" variant="text" onClick={handleCloseReopenConfirmModal}>
              Cancel
            </CustomButton>
            <CustomButton
              size="medium"
              color="error"
              variant="contained"
              startIcon={<LoadingIcon loading={isLoadingReopenInvoice} />}
              onClick={handleReopenInvoice}
              disabled={reopenReason.trim().length === 0 || isLoadingReopenInvoice}
            >
              Reopen
            </CustomButton>
          </DialogActions>
        </Dialog>
      )}
      {openMarkAsApproveConfirmModal && (
        <Dialog open={openMarkAsApproveConfirmModal} maxWidth={DIALOG_MAX_WIDTHS.XS} fullWidth>
          <DialogTitle className="dialog-title">
            <div className="heading-m">Are you sure?</div>
            <div className="vertical_center_align">
              <IconButton onClick={handleCloseMarkAsApproveConfirmModal}>
                <Close />
              </IconButton>
            </div>
          </DialogTitle>
          <DialogContent dividers sx={{ p: 2 }}>
            <Alert severity="info">Once the documents are approved, they will not be allowed to update.</Alert>
          </DialogContent>
          <DialogActions className="dialog-actions">
            <CustomButton
              size="medium"
              colorToken="violet"
              variant="text"
              onClick={handleCloseMarkAsApproveConfirmModal}
            >
              Cancel
            </CustomButton>
            <CustomButton
              size="medium"
              colorToken="violet"
              variant="contained"
              disabled={isLoadingApproveInvoice}
              startIcon={<LoadingIcon loading={isLoadingApproveInvoice} />}
              onClick={() => {
                handleApproveInvoice();
              }}
            >
              Approve
            </CustomButton>
          </DialogActions>
        </Dialog>
      )}
      {openRejectResponseConfirmModal && (
        <Dialog open={openRejectResponseConfirmModal} maxWidth={DIALOG_MAX_WIDTHS.XS} fullWidth>
          <DialogTitle className="dialog-title">
            <div className="heading-m error-dialog-icon">
              <div>
                <WarningAmberIcon color="error" />
              </div>
              Are you sure?
            </div>
            <div className="vertical_center_align">
              <IconButton
                onClick={() => {
                  handleCloseRejectResponseConfirmModal();
                }}
              >
                <Close />
              </IconButton>
            </div>
          </DialogTitle>
          <DialogContent dividers sx={{ p: 2 }}>
            <Autocomplete
              freeSolo
              options={Object.values(IssueCategorizationOptions)}
              value={rejectReason}
              onChange={(_event, newValue) => {
                setRejectReason(newValue || ""); // Set selected or custom input
              }}
              onInputChange={(event, newInputValue) => {
                if (event?.type === "change") {
                  setRejectReason(newInputValue); // Update while typing
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  placeholder="Provide a reason for rejection."
                  size="small"
                  multiline
                  maxRows={4}
                  className="update-custom-border-radius"
                />
              )}
            />
          </DialogContent>
          <DialogActions className="dialog-actions">
            <CustomButton size="medium" color="error" variant="text" onClick={handleCloseRejectResponseConfirmModal}>
              Cancel
            </CustomButton>
            <CustomButton
              size="medium"
              color="error"
              variant="contained"
              startIcon={<LoadingIcon loading={isLoadingRejectInvoice} />}
              onClick={() => {
                handleRejectInvoice();
              }}
              disabled={rejectReason?.trim()?.length === 0 || isLoadingRejectInvoice}
            >
              Reject
            </CustomButton>
          </DialogActions>
        </Dialog>
      )}
      {openViniculumConfirmModal && (
        <Dialog open={openViniculumConfirmModal} maxWidth={DIALOG_MAX_WIDTHS.XS} fullWidth>
          <DialogTitle className="dialog-title">
            <div className="heading-m">Are you sure?</div>
            <div className="vertical_center_align">
              <IconButton onClick={handleCloseViniculumConfirmModal}>
                <Close />
              </IconButton>
            </div>
          </DialogTitle>
          <DialogContent dividers sx={{ p: 2 }}>
            <Alert severity="warning">
              Please make sure all the attachments are uploaded in viniculum, only then mark it as “Update in Viniculum”
            </Alert>
          </DialogContent>
          <DialogActions className="dialog-actions">
            <CustomButton size="medium" colorToken="violet" variant="text" onClick={handleCloseViniculumConfirmModal}>
              Cancel
            </CustomButton>
            <CustomButton
              size="medium"
              colorToken="violet"
              variant="contained"
              disabled={isLoadingUpdateInViniculum}
              startIcon={<LoadingIcon loading={isLoadingUpdateInViniculum} />}
              onClick={() => {
                handleUpdateInViniculum();
              }}
            >
              Update in Viniculum
            </CustomButton>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

export default RejectedInvoicesTakeActionModal;
